import { ReactElement, ReactNode } from 'react';
import { cn } from '../utils/cn';

interface ChartCardProps {
  children: ReactNode;
  height?: number | string;
  className?: string;
  isLoading?: boolean;
  padding?: boolean;
}

export default function ChartCard({
  children,
  height,
  className,
  isLoading = false,
  padding = false,
}: ChartCardProps): ReactElement {
  const heightStyle = typeof height === 'number'
    ? { height: `${height}px` }
    : height
      ? { height }
      : undefined;

  return (
    <div
      className={cn(
        'cr-relative cr-rounded-xl cr-bg-clip-border cr-shadow-md',
        padding && 'cr-p-4',
        className
      )}
      style={heightStyle}
    >
      {isLoading && <LoadingOverlay />}
      {children}
    </div>
  );
}

export function LoadingOverlay(): ReactElement {
  return (
    <div className="cr-absolute cr-inset-0 cr-z-10 cr-flex cr-items-center cr-justify-center cr-bg-white cr-bg-opacity-75">
      <div className="cr-h-8 cr-w-8 cr-animate-spin cr-rounded-full cr-border-4 cr-border-gray-300 cr-border-t-blue-600" />
    </div>
  );
}
